import axios from "axios";

const API_URL = "/api/website";

export const getWebsitePages = async () => {
  const res = await axios.get(`${API_URL}/pages`);
  return res.data;
};

export const saveWebsitePage = async (slug, page) => {
  const res = await axios.put(`${API_URL}/pages/${slug}`, page);
  return res.data;
};

export const deleteWebsitePage = async (slug) => {
  const res = await axios.delete(`${API_URL}/pages/${slug}`);
  return res.data;
};

export const getWebsiteSettings = async () => {
  const res = await axios.get(`${API_URL}/settings`);
  return res.data;
};

export const saveWebsiteSettings = async (settings) => {
  const res = await axios.put(`${API_URL}/settings`, settings);
  return res.data;
};

/** files: File[] — returns [{ src }] with /uploads/website/ paths. */
export const uploadWebsiteImages = async (files) => {
  const form = new FormData();
  for (const f of files) form.append("files", f);
  const res = await axios.post(`${API_URL}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
